import { BASE_URL } from "../../../utility/BaseUrl";

export const SliderComponentChild = ({ item }) => {
  if (item.is_active)
    return (
      <>
        <div className="home-big-slider-item position-relative">
          <div className="home-big-slider-item-hero">
            <a href={item.link} target="_blank" title={item.link_title}>
              <img
                className="home-big-slider-item-image"
                src={BASE_URL + item.picture}
                alt={item.picture_alt}
                title={item.picture_title}
              />
            </a>
          </div>
        </div>
      </>
    );
};

export const SliderComponentChild2 = ({ item }) => {
  if (item.is_active)
    return (
      <>
        <div className="main-slider-item">
          <a href={item.link} target="_blank" title={item.link_title}>
            <img
              src={BASE_URL + item.picture}
              alt={item.picture_alt}
              title={item.picture_title}
              className="rounded shadow-lg my-10 my-sm-10"
            />
          </a>
        </div>
      </>
    );
};
